
import './helpers/is-in-view-helper/is-in-view-helper.js';
import FormQuiz from "./quizForm";
import Header from "./Header";

import Slider from "./Slider";
import Video from "./Video";
import ProductSlider from "./ProductSlider";
import Gallery from "./Gellery";
import RelatedGallery from "./RelatedGellery";
import QuantityButtonsInit from "./QuantityButtons";
import Accordion from './Accordion';
import Popup from './popup';
import ProductPopup from "./ProductPopup";
import RelatedProductPopup from "./RelatedProductPopup";
import inViewport from './is-in-viewport.js';


(function() {
  const header = new Header();
  header.init();

  const slider = new Slider();
  slider.init();

  const productSlider = new ProductSlider();
  productSlider.init();

  const gallery = new Gallery();
  gallery.init();

  const relatedGallery = new RelatedGallery();
  relatedGallery.init();

  new QuantityButtonsInit();

  const video = new Video();
  video.init();

  const accordion = new Accordion();
  accordion.init();

  const popup = new Popup;
  popup.init();

  const productPopup = new ProductPopup;
  productPopup.init();

  const relatedProductPopup = new RelatedProductPopup;
  relatedProductPopup.init();

  inViewport.init();

})();
